export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
              <span className="w-9 h-9 rounded-md bg-gradient-to-br from-primary-500 to-accent-400 flex items-center justify-center">
                <i className="ri-shield-check-line text-white text-lg" />
              </span>
              <span className="font-heading font-bold text-sm tracking-wide">
                THE TECH CONSULTANTS LLC
              </span>
            </a>
            <p className="mt-4 text-sm text-white/60">Your Technology. Our Expertise.</p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-white/50">
              Links
            </h4>
            <ul className="mt-4 space-y-2.5">
              {[
                { label: "Services", href: "#services" },
                { label: "About", href: "#about" },
                { label: "Contact", href: "#contact" },
                { label: "Privacy Policy", href: "#top" },
              ].map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-sm text-white/75 hover:text-white transition-colors cursor-pointer"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-white/50">
              Contact
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-white/75">
              <li>
                <a
                  href="mailto:nick@thetechconsultantsllc.com"
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  nick@thetechconsultantsllc.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+18184696734"
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  (818) 469-6734
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50">
            © 2026 The Tech Consultants LLC. All rights reserved.
          </p>
          <p className="text-xs text-white/40">California-Based IT Consulting &amp; Managed Services</p>
        </div>
      </div>
    </footer>
  );
}